import { Navigate } from 'react-router-dom';
import { ELinksName, EParams } from 'services/constants/list-links-sidebar';
import ErrorRoutes from './ErrorRoutes';
import Suport from 'pages/Dashboard/Suport/Suport';
import SuportLayout from 'layouts/SuportLayout/SuportLayout';

const SuportRoutes = {
  path: '/',
  element: <SuportLayout />,
  children: [
    {
      element: <Suport />,
      path: ELinksName.SUPORT + EParams.TAB,
    },
    {
      element: <Navigate to={ELinksName.SUPORT + EParams.TAB} replace />,
      path: '/',
    },
    ErrorRoutes,
  ],
};

export default SuportRoutes;
